import { BaseService } from '@/core/base-service';

export default class CompanySubscriptionMasterService extends BaseService<any> {
  public constructor() {
    super('services/servicescard/api/master/company-subscription');
  }
}
